import { supabase } from '../../supabase'
import type { DatabaseRow, RepositoryResult } from '../types/database.types'
import { failure, success } from './result'

export const WorkflowRepository = {
  async getProspectWorkflow(
    prospectId: string,
  ): Promise<RepositoryResult<DatabaseRow | null>> {
    const { data, error } = await supabase
      .from('prospect_workflows')
      .select('*, prospects(*)')
      .eq('prospect_id', prospectId)
      .maybeSingle()

    return error
      ? failure(error)
      : success((data ?? null) as DatabaseRow | null)
  },

  async listSteps(): Promise<RepositoryResult<DatabaseRow[]>> {
    const { data, error } = await supabase
      .from('workflow_steps')
      .select('id, code, step_order')
      .order('step_order', { ascending: true })

    return error ? failure(error) : success((data ?? []) as DatabaseRow[])
  },

  async listQueue(): Promise<RepositoryResult<DatabaseRow[]>> {
    const { data, error } = await supabase
      .from('prospect_workflows')
      .select('*, prospects(*), workflow_steps(id, code, step_order)')
      .order('next_action_due_at', { ascending: true, nullsFirst: false })

    return error ? failure(error) : success((data ?? []) as DatabaseRow[])
  },

  async listHistory(
    prospectId: string,
  ): Promise<RepositoryResult<DatabaseRow[]>> {
    const { data, error } = await supabase
      .from('workflow_history_overview')
      .select('*')
      .eq('prospect_id', prospectId)
      .order('occurred_at', { ascending: false })

    return error ? failure(error) : success((data ?? []) as DatabaseRow[])
  },

  async updateAfterFollowUp(
    prospectId: string,
    payload: { next_action_due_at: string; state: 'waiting' },
  ): Promise<RepositoryResult<null>> {
    const { error } = await supabase
      .from('prospect_workflows')
      .update(payload)
      .eq('prospect_id', prospectId)

    return error ? failure(error) : success(null)
  },

  async advance(
    prospectId: string,
    payload: Record<string, unknown>,
  ): Promise<RepositoryResult<null>> {
    const { error } = await supabase
      .from('prospect_workflows')
      .update(payload)
      .eq('prospect_id', prospectId)

    return error ? failure(error) : success(null)
  },
}
